// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"ecbe3293","548":"95a147a6"}[chunkId] + ".chunk.js";
};